<div class="select-container">
  <app-emu-list-input
    [name]="'DASHBOARD.TEMPLATES'"
    [clearButtonHidden]="true"
    [filteredOptions$]="templates$"
    [className]="'dashboard-settings'"
    (optionSelected)="templateSelected($event)"
    [placeholder]="inputPlaceholder | async"
  >
    <ng-template let-item>
      <div class="device-row">
        <span class="device-name">{{ item.name }}</span>
        <mat-icon
          class="delete-icon"
          (click)="deleteTemplate(item.id); $event.preventDefault(); $event.stopPropagation()"
          svgIcon="delete"
        ></mat-icon>
      </div>
    </ng-template>
  </app-emu-list-input>
</div>
